import { Report192 } from "../../../components/borrowSystem/Report/Report192";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report192Container() {
  const titleName =
    " สรุปข้อมูลการอนุมัติและทำสัญญากู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน"; //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report192 />
      <Footer />
    </div>
  );
}
